import { useMemo } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../../assets/logo.png";
import { NAV_ICONS, IconLogout } from "../../ui/icons";
import ds from "./desktopSidebar.module.css";

function navClass({ isActive }) {
  return isActive ? `${ds.navLink} ${ds.navLinkActive}` : ds.navLink;
}

function splitSections(sections) {
  const primary = [];
  const more = [];
  for (const section of sections) {
    if (section.label) {
      more.push(...(section.items || []));
    } else {
      primary.push(...(section.items || []));
    }
  }
  return { primary, more };
}

function NavItems({ items, getBadge, className = navClass }) {
  return items.map((item) => {
    const Icon = NAV_ICONS[item.icon] || NAV_ICONS.overview;
    const badge = getBadge?.(item);
    return (
      <NavLink
        key={item.id || item.to}
        to={item.to}
        end={item.end}
        className={className}
        data-tour={item.id || undefined}
      >
        <Icon className={ds.navIcon} />
        <span className={ds.navLabel}>{item.label}</span>
        {badge > 0 ? (
          <span className={ds.navBadge}>{badge > 9 ? "9+" : badge}</span>
        ) : null}
      </NavLink>
    );
  });
}

export default function DesktopSidebar({
  homeTo = "/",
  brandName,
  sections = [],
  onLogout,
  getBadge,
}) {
  const { primary, more } = useMemo(() => splitSections(sections), [sections]);

  return (
    <aside className={ds.leftSidebar}>
      <div className={ds.sidebarTop}>
        <Link to={homeTo} className={ds.brand}>
          <img
            src={logo}
            alt=""
            className={ds.brandLogo}
            width={28}
            height={28}
          />
          <div className={ds.brandText}>
            <span className={ds.brandName}>{brandName}</span>
          </div>
        </Link>
      </div>

      <nav className={ds.nav} aria-label="Основная навигация">
        <div className={ds.navPrimary}>
          <NavItems items={primary} getBadge={getBadge} />
          {more.length > 0 ? (
            <>
              <p className={ds.navSectionLabel}>Ещё</p>
              <NavItems items={more} getBadge={getBadge} />
            </>
          ) : null}
        </div>
      </nav>

      <div className={ds.sidebarBottom}>
        {onLogout ? (
          <button type="button" className={ds.logoutLink} onClick={onLogout}>
            <IconLogout className={ds.navIcon} />
            <span className={ds.navLabel}>Выйти</span>
          </button>
        ) : null}
      </div>
    </aside>
  );
}

export { ds as desktopSidebarStyles };
